import React from 'react';
import { Globe } from 'lucide-react';

const StandardFooter = ({ onContactClick }) => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/logo.png" alt="Offworld Ventures" className="footer-logo-img" />
        </div>
        <div className="footer-tagline">WE BUILD WHAT'S NEXT</div>
        <div className="footer-location">
          <Globe size={20} />
          <span>Based on Earth - For Now</span>
        </div>
        <div className="footer-links">
          <a href="/portfolio" className="footer-link">Portfolio</a>
          <span className="footer-divider">•</span>
          {onContactClick &&
          <>
              <button onClick={onContactClick} className="footer-link footer-link-button">Contact</button>
              <span className="footer-divider">•</span>
            </>
          }
          <a href="/privacy" className="footer-link">Privacy</a>
          <span className="footer-divider">•</span>
          <a href="/terms" className="footer-link">Terms</a>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Offworld Ventures, LLC. All rights reserved.
        </div>
      </div>
    </footer>);

};

export default StandardFooter;